import { Layout } from "antd";
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ClipboardListIcon,
  CurrencyDollarIcon,
  LogoutIcon,
  OfficeBuildingIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import packageJson from "../../../package.json";
import { logout } from "../../actions/authActions";
import boltLogo from "../../assets/GoBolt-Primary-for-Dark-Bg.png";
import boltLightning from "../../assets/logo-gobolt-primary-icon.svg";
import "./AppHeader.css";

const { Sider } = Layout;

class AppHeader extends Component {
  state = {
    collapsed: false,
  };

  toggleCollapsed = () => {
    this.setState((prev) => ({ collapsed: !prev.collapsed }));
  };

  render() {
    const { collapsed } = this.state;
    const { location, roles, isAuthenticated, isUseCoreRatesFeatureFlag } = this.props;
    const isAdmin = roles && (roles.includes("super_admin") || roles.includes("admin"));
    const isSuperAdmin = roles && roles.includes("super_admin");
    const currentPath = location.pathname;

    const navItemClass = (path) => `nav-item${currentPath === path ? " nav-item--selected" : ""}`;

    return (
      <div>
        {isAuthenticated && (
          <Sider trigger={null} collapsed={collapsed} className="sider" style={{ background: "#00282b" }}>
            <div className={`nav-inner${collapsed ? " nav-inner--collapsed" : ""}`}>
              <div className="nav-top">
                {collapsed ? (
                  <div className="nav-logo-collapsed">
                    <div className="nav-logo-icon">
                      <img src={boltLightning} alt="GoBolt" />
                    </div>
                    <button className="nav-collapse-btn" onClick={this.toggleCollapsed} aria-label="Expand sidebar">
                      <ChevronDoubleRightIcon />
                    </button>
                  </div>
                ) : (
                  <div className="nav-logo-row">
                    <div className="nav-logo-full">
                      <img src={boltLogo} alt="GoBolt" />
                    </div>
                    <button className="nav-collapse-btn" onClick={this.toggleCollapsed} aria-label="Collapse sidebar">
                      <ChevronDoubleLeftIcon />
                    </button>
                  </div>
                )}

                <div className="nav-sections">
                  <div className="nav-section">
                    {!collapsed && <div className="nav-section-heading">Orders</div>}
                    <Link to="/dashboard" className={navItemClass("/dashboard")}>
                      <span className="nav-item-icon">
                        <ClipboardListIcon />
                      </span>
                      {!collapsed && <span className="nav-item-label">Orders</span>}
                    </Link>
                    {isAdmin && !isUseCoreRatesFeatureFlag && (
                      <Link to="/orders/rates" className={navItemClass("/orders/rates")}>
                        <span className="nav-item-icon">
                          <CurrencyDollarIcon />
                        </span>
                        {!collapsed && <span className="nav-item-label">Rates</span>}
                      </Link>
                    )}
                  </div>

                  {isAdmin && (
                    <div className="nav-section">
                      {!collapsed && <div className="nav-section-heading">Merchants</div>}
                      <Link to="/merchants/viewMerchants" className={navItemClass("/merchants/viewMerchants")}>
                        <span className="nav-item-icon">
                          <OfficeBuildingIcon />
                        </span>
                        {!collapsed && <span className="nav-item-label">Merchants</span>}
                      </Link>
                    </div>
                  )}

                  {isSuperAdmin && (
                    <div className="nav-section">
                      {!collapsed && <div className="nav-section-heading">GoBolt Users</div>}
                      <Link to="/users" className={navItemClass("/users")}>
                        <span className="nav-item-icon">
                          <UserGroupIcon />
                        </span>
                        {!collapsed && <span className="nav-item-label">GoBolt Users</span>}
                      </Link>
                    </div>
                  )}
                </div>
              </div>

              <div className="nav-bottom">
                <button className="nav-item nav-item--button" onClick={this.props.logout}>
                  <span className="nav-item-icon">
                    <LogoutIcon />
                  </span>
                  {!collapsed && <span className="nav-item-label">Log out</span>}
                </button>
                {!collapsed && <div className="nav-version">v{packageJson?.version}</div>}
              </div>
            </div>
          </Sider>
        )}
      </div>
    );
  }
}

AppHeader.propTypes = {
  isAuthenticated: PropTypes.bool,
  isUseCoreRatesFeatureFlag: PropTypes.bool,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isUseCoreRatesFeatureFlag: state.featureFlag.useCoreRates,
  roles: state.auth.roles,
});

export default connect(mapStateToProps, { logout })(withRouter(AppHeader));
